import { createBrowserRouter } from "react-router";
import { Layout } from "./components/layout";
import { Home } from "./pages/home";
import { About } from "./pages/about";
import { Projects } from "./pages/projects";
import { ProjectDetail } from "./pages/project-detail";
// import { Donate } from "./pages/donate";
import { Apply } from "./pages/apply";
import { Reports } from "./pages/reports";
import { Blog } from "./pages/blog";
import { GetInvolved } from "./pages/get-involved";
import { Contact } from "./pages/contact";
import { PrivacyPolicy } from "./pages/privacy";
import { TermsOfUse } from "./pages/terms";
import { NotFound } from "./pages/not-found";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: Home },
      { path: "about", Component: About },
      { path: "projects", Component: Projects },
      { path: "projects/:slug", Component: ProjectDetail },
      // { path: "donate", Component: Donate },
      { path: "apply", Component: Apply },
      { path: "reports", Component: Reports },
      { path: "blog", Component: Blog },
      { path: "get-involved", Component: GetInvolved },
      { path: "contact", Component: Contact },
      { path: "privacy", Component: PrivacyPolicy },
      { path: "terms", Component: TermsOfUse },
      { path: "*", Component: NotFound },
    ],
  },
]);
